import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';
import Announcement from '../../../components/management/announcement/Announcement';
import StudentFeeCards from '../../../components/academic/student/StudentFeeCards';
import StudentProfileCard from '../../../components/academic/student/StudentProfileCard';
import StudentFeeSummaryTable from '../../../components/academic/student/StudentFeeSummaryTable';
import { getProfileForStudent } from '../../../services/student.service';
import { getStudentTotalFeeCollection } from '../../../services/fee.service';
import Card, { CardBody, CardHeader, CardLabel, CardTitle, CardActions } from '../../../components/bootstrap/Card';
import Button from '../../../components/bootstrap/Button';
import { TableLoader } from '../../../services/loader.services';

const StudentDashboard = () => {
	const { userAccountId, userTypeId } = useContext(AuthContext);
	const navigate = useNavigate();
	const [studentTotalFeeCollectionData, setStudentTotalFeeCollectionData] = useState<any>([]);
	const [studentProfileData, setStudentProfileData] = useState<any>([]);
	const [isProfileLoading, setIsProfileLoading] = useState(true);
	const [isFeeLoading, setIsFeeLoading] = useState(true);

	useEffect(() => {
		if (userTypeId == 10 && userAccountId) {
			getStudentProfile(Number(userAccountId));
			getStudentTotalFeeCollectionList(Number(userAccountId));
		} else {
			setIsProfileLoading(false);
			setIsFeeLoading(false);
		}
	}, [userTypeId, userAccountId]);

	function getStudentProfile(studentDetailsId: number) {
		getProfileForStudent(studentDetailsId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.studentProfile[0];
					if (data != undefined) {
						setStudentProfileData(data);
					}
				}
				setIsProfileLoading(false);
			}, error => {
				console.error(error);
				setIsProfileLoading(false);
			}
		)
	}

	function getStudentTotalFeeCollectionList(studentDetailsId: number) {
		getStudentTotalFeeCollection(studentDetailsId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.studentTotalFeeCollection;
					if (data != undefined) {
						setStudentTotalFeeCollectionData(data);
					}
				}
				setIsFeeLoading(false);
			}, error => {
				console.error(error);
				setIsFeeLoading(false);
			}
		)
	}

	const isLoading = isProfileLoading || isFeeLoading;

	if (isLoading) {
		return (
			<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
				<Page container='fluid'>
					<div className='row align-items-center justify-content-center' style={{ minHeight: '50vh' }}>
						<TableLoader />
					</div>
				</Page>
			</PageWrapper>
		);
	}

	return (
		<PageWrapper title={demoPagesMenu.sales.subMenu.dashboard.text}>
			{/* No SubHeader with "Today Overview" is rendered here for student dashboard */}
			<Page container='fluid'>
				<div className='row g-4'>
					<div className='col-xl-12'>
						<Announcement />
					</div>
					<div className='col-xl-12'>
						<StudentFeeCards studentTotalFeeCollectionData={studentTotalFeeCollectionData} />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default StudentDashboard;
